import {Component, Input, OnInit} from '@angular/core';
import {GridOptions} from 'ag-grid';
import {BooleanCheckComponent} from 'app/pages/A2-utils/grid-components/boolean-check/boolean-check.component';
import {
  ProgressBarCellComponent
} from 'app/pages/A2-utils/grid-components/progress-bar-cell/progress-bar-cell.component';
import {OnDemandDriversService} from '../../on-demand-drivers.service';
import {SweetAlertHelper} from 'app/core/helpers/sweet-alert-helper.service';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-driver-courses-module',
  templateUrl: './courses-module.component.html',
  styleUrls: ['./courses-module.component.scss'],
})
export class CoursesModuleComponent implements OnInit {
  coursesGrid: GridOptions;
  notPassed = true;
  valueDriverId: number;
  existCourses = false;
  @Input() set driverId(val: number) {
    if (val !== 0 && val != undefined) {
      this.getModulos(val);
    }
  }
  showDownloadBtn$: Observable<boolean>;

  constructor(
    protected service: OnDemandDriversService,
    private sweetAlertHelper: SweetAlertHelper
  ) {}

  ngOnInit() {
    this.coursesGrid = <GridOptions>{};
    this.configureGrid();
    this.showDownloadBtn$ = this.service.actionNames$
      .map((actionNames) => !!actionNames && actionNames.includes('showDownloadCertificate'));
  }

  private configureGrid() {
    const self = this;
    this.coursesGrid.columnDefs = [
      {
        headerName: 'Title',
        field: 'title',
        colId: 'title',
      },
      {
        headerName: 'Score',
        field: 'score',
        cellRendererFramework: ProgressBarCellComponent,
      },
      {
        headerName: 'Passed',
        field: 'passed',
        cellRendererFramework: BooleanCheckComponent,
      },
    ];

    this.coursesGrid.onGridReady = function () {
      // self.getModulos();
      self.coursesGrid.api.sizeColumnsToFit();
    };

    this.coursesGrid.onGridSizeChanged = (params) => {
      if (params && params.api) {
        params.api.sizeColumnsToFit();
      }
    };
  }

  private getModulos(driverId: number) {
    this.existCourses = false;
    this.valueDriverId = driverId;
    this.service
      .getModulesCourses(driverId)
      .subscribe((data) => {
        if (!this.coursesGrid.api) { return; }
        this.coursesGrid.api.setRowData(data);
        if (!data) { return; }
        this.existCourses = true;
        this.notPassed = data.some((sel: any): boolean => !sel.passed);
      });
  }

  public downloadCertification(): void {
    if (!this.valueDriverId || this.notPassed) {
      this.sweetAlertHelper.createCustomAlert({
        type: 'error',
        title: 'Downloading Certificate',
        text: 'The driver has not passed all the courses.',
      });
    } else {
      this.service.downloadCertificationPDF(this.valueDriverId).subscribe(
        (res) => {
          const fileURL = URL.createObjectURL(res);
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = 'certification.pdf';
          link.click();
        },
        (err) => {
          this.sweetAlertHelper.captureException(err);
        }
      );
    }
  }

  get disabledDownloadBtn(): boolean {
    return !this.valueDriverId || this.notPassed;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/components/courses-module/courses-module.component.ts